'use client';

import { FC, useState } from 'react';

import GridView from '@/components/BlogPage/PostsList/GridView';
import { BlogPostDto } from '@/components/BlogPage/types';
import ShowMoreFilledButton from '@/components/shared/ShowMoreFilledButton';
import { Typography } from '@/components/shared/Typography';
import { RELEVANT_BLOG_POSTS_PAGE_SIZE } from '@/lib/blog/const';

import css from './style.module.scss';

interface Props {
	posts: BlogPostDto[];
	hasMoreFromTags: boolean;
}

const RelevantPostsContent: FC<Props> = ({ posts, hasMoreFromTags }) => {
	const [visibleCount, setVisibleCount] = useState(RELEVANT_BLOG_POSTS_PAGE_SIZE);

	const visiblePosts = hasMoreFromTags ? posts.slice(0, visibleCount) : posts;
	const hasMore = hasMoreFromTags && visibleCount < posts.length;

	if (!visiblePosts.length) return null;

	return (
		<section className={css.wrapper}>
			<Typography variant="h3" tag="h2" className={css.title}>
				Picked for you
			</Typography>

			<GridView posts={visiblePosts} />

			{hasMore ? (
				<ShowMoreFilledButton
					className={css.showMoreButton}
					label="Load more articles"
					onClick={() => setVisibleCount(count => count + RELEVANT_BLOG_POSTS_PAGE_SIZE)}
				/>
			) : null}
		</section>
	);
};

export default RelevantPostsContent;
